export default {
    agree    : 'OK',
    disagree : 'Annuler',
    title    : 'Palette'
} ;